import { IconType } from "react-icons/lib";
import { TbBuildingSkyscraper, TbHeartbeat } from "react-icons/tb";

import { softColors } from "./colors";

export type HotelPlanningTabItem = {
    component: () => IconType;
    hover: string;
    bg: string;
    label: string;
    text: string;
    tooltip: {
        title: string;
        description: string;
    };
    value: string;
};

export type HotelPlanningTabsList = HotelPlanningTabItem[];

export const hotelPlanningTabsList: HotelPlanningTabsList = [
    {
        label: "Otele Gidiş",
        component: () => TbBuildingSkyscraper,
        ...softColors.grey,
        tooltip: {
            title: "Otele Gidişi",
            description: "Hastaların otele gidiş takibi için kullanılır ",
        },
        value: "/hastane-otel/departure",
    },
    // {
    //     label: "Otelden Alış",
    //     component: () => TbBuildingHospital,
    //     ...softColors.grey,
    //     tooltip: {
    //         title: "Otelden Alış",
    //         description: "Hastaların otelden alış takibi için kullanılır ",
    //     },
    //     value: "/hastane-otel/",
    // },
    {
        label: "Kliniğe Geliş",
        component: () => TbHeartbeat,
        ...softColors.grey,
        tooltip: {
            title: "Kliniğe Geliş",
            description: "Hastaların otelden kliniğe transfer planlaması",
        },
        value: "/hastane-otel/",
    },
];
